// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ant-list-item[data-v-3ed37c50] {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
